var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-info-circle",
    "data-name": "Icon awesome-info-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 12.5,
    viewBox: "0 0 12.5 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info-circle-2",
    "data-name": "Icon awesome-info-circle",
    d: "M6.813.563a6.25,6.25,0,1,0,6.25,6.25A6.251,6.251,0,0,0,6.813.563Zm0,2.772A1.058,1.058,0,1,1,5.754,4.393,1.058,1.058,0,0,1,6.813,3.335Zm1.411,6.4a.3.3,0,0,1-.3.3H5.7a.3.3,0,0,1-.3-.3v-.6a.3.3,0,0,1,.3-.3h.3V7.216H5.7a.3.3,0,0,1-.3-.3v-.6a.3.3,0,0,1,.3-.3H7.317a.3.3,0,0,1,.3.3v2.52h.3a.3.3,0,0,1,.3.3Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#41a6e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.1e642f9719cac1827ca4cf418bb4dc82.svg";
export { ForwardRef as ReactComponent };